var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowLeft = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--arrow-left",
  width: 14,
  height: 14,
  viewBox: "0 0 18 18",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.2 8.1L12 .4c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8L6.9 9l6.8 6.8c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0L4.2 9.9c-.2-.3-.3-.6-.3-.9 0-.3.1-.6.3-.9z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconArrowLeft.442fb509.svg";
export { ForwardRef as ReactComponent };